import axios from "axios";
import * as cognito from "./cognito";

const apiStage = process.env.NODE_ENV === "production" ? "prod" : "dev";
const baseURL = `https://n0wgb91ov1.execute-api.ap-northeast-1.amazonaws.com/${apiStage}/api`;
const alias = process.env.VUE_APP_CHRONOLOGY_ALIAS;

const createApi = async () => {
  const auth = await cognito.isAuthenticated();
  const token = auth ? auth.idToken.jwtToken : null;
  return axios.create({
    responseType: "json",
    baseURL: baseURL,
    headers: {
      Authorization: token
    }
  });
};

const get = async (path, params = {}) => {
  const api = await createApi();
  return api
    .get(`${path}/${alias}`, { params: params })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return null;
    });
};

const post = async (path, params = {}) => {
  const api = await createApi();
  return api
    .post(`${path}/${alias}`, params)
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return null;
    });
};

const del = async (path, params = {}) => {
  const api = await createApi();
  return api
    .delete(`${path}/${alias}`, { data: params })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error(err);
      return null;
    });
};

const uploadFile = async file => {
  const params = {
    contentType: file.type
  };
  const response = await get("/presigned_upload_url", params);
  if (!response) {
    return null;
  }
  const presignedUrl = response.url;
  const s3Key = response.key;
  if (!presignedUrl || !s3Key) return null;

  const putResponse = await axios({
    method: "PUT",
    url: presignedUrl,
    headers: {
      "Content-Type": file.type
    },
    data: file
  });
  if (putResponse.status === 200) {
    return s3Key;
  }
};

export default { get, post, del, uploadFile };
